import {
  StoreComplexItemEditType,
  StoreComplexItemUpdateType,
} from 'modules/stores/store/types/store-item-interface'

export const getComplexItemUpdateData = <T extends StoreComplexItemEditType>(
  item: T,
): StoreComplexItemUpdateType<T> => {
  const { id, itemId, thumbnail, type, position, ...itemToUpdate } = item
  return {
    ...itemToUpdate,
    thumbnailId: item.thumbnail?.id ?? null,
  }
}
